import React from "react";
import { useCopy } from "./ui";

export default function AuthGoogleChoice({ role, children }) {
    const { c } = useCopy();
    return role === "advisor"
        ? <p className="aw-google-notice">{c("Use email to create or access an advisor account. For an existing Google account, sign in in Student mode, then enable advisor tools from My advisors.", "Utilisez votre e-mail pour créer un compte encadrant ou vous y connecter. Pour un compte Google existant, connectez-vous en mode Étudiant, puis activez les outils d’encadrement depuis Mes encadrants.")}</p>
        : <>{children}</>;
}
